import { Link } from 'react-router-dom';
import ROUTES from '../../../routes/Routes.js';

export default function UserActionsDropdown({ user, onSuspend, onDelete }) {
    return (
        <div className="dropdown-center">
            <button className="btn dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" style={{color: "#0f6cbf"}}>
                <i className="bi bi-gear-fill"></i>
            </button>
            {user.userRole?.id === 1 ? (
                <>
                    <ul className="dropdown-menu">                                                            
                        <li><Link to={`${ROUTES.EDITUSER}/${user.id}`} className="dropdown-item"><i className="bi bi-gear-fill"></i> Editar </Link></li>
                    </ul>
                </>
            ) : (
                <>
                    <ul className="dropdown-menu">
                        <li><Link to={`${ROUTES.EDITUSER}/${user.id}`} className="dropdown-item"><i className="bi bi-gear-fill"></i> Editar </Link></li>
                        <li>
                            <button className="dropdown-item" onClick={() => onSuspend(user)}>
                                {user.suspended ? (
                                    <>
                                        <i className="bi bi-eye-fill"></i> Activar cuenta de usuario
                                    </>
                                ) : (
                                    <>
                                        <i className="bi bi-eye-slash-fill"></i> Suspender cuenta de usuario
                                    </>
                                )}
                            </button>
                        </li>
                        <li>
                            <button className="dropdown-item" style={{ color: user.suspended ? "" : "#ca3120" }} disabled={user.suspended} onClick={() => onDelete(user)}>
                                <i className="bi bi-trash-fill"></i> Borrar
                            </button>
                        </li>
                    </ul>
                </>
            )}
        </div>
    );
}